var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleLogoV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 26,
    viewBox: "0 0 21 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24167_10815)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3318 8.8634C20.1822 8.9804 17.5404 10.4806 17.5404 13.8164C17.5404 17.6748 20.902 19.0398 21.0026 19.0736C20.9871 19.1568 20.4686 20.943 19.2302 22.763C18.126 24.3646 16.9729 25.9636 15.2186 25.9636C13.4643 25.9636 13.0128 24.9366 10.9876 24.9366C9.014 24.9366 8.31229 25.9974 6.70762 25.9974C5.10295 25.9974 3.98329 24.5154 2.69595 22.6954C1.20479 20.5582 0 17.238 0 14.0868C0 9.0324 3.26093 6.3518 6.47027 6.3518C8.17555 6.3518 9.59705 7.4802 10.6677 7.4802C11.6867 7.4802 13.2759 6.2842 15.216 6.2842C15.9512 6.2842 18.593 6.3518 20.3318 8.8634ZM14.295 4.1444C15.0973 3.185 15.6649 1.8538 15.6649 0.5226C15.6649 0.338 15.6494 0.1508 15.6158 0C14.3104 0.0494 12.7574 0.8762 11.8209 1.9708C11.0856 2.8132 10.3994 4.1444 10.3994 5.4938C10.3994 5.6966 10.4329 5.8994 10.4484 5.9644C10.531 5.98 10.6651 5.9982 10.7993 5.9982C11.9705 5.9982 13.4436 5.2078 14.295 4.1444Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24167_10815"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleLogoV2);
export default __webpack_public_path__ + "static/media/apple-logo-v2.5c204023fb40b928b9fbfeef5882d477.svg";
export { ForwardRef as ReactComponent };